module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/hiking.svg?a63718456717ae6dcb8a2b47cbd5918c";